<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7PKrYB/tc-custom/9781446360286.jpg?1694191843879" alt="This image is the cover for the book Easy Buttercream Cake Designs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Easy Buttercream Cake Designs
      </h1>
      <p class="bookDescription body article font2">
        <b>Top off your cake with a sweet work of art!</b><br/>  <br/> Do you dream of being able to make beautiful decorated cakes for any occasion? <i>Easy Buttercream Cake Designs</i> will teach you the essential buttercream cake decorating techniques you need to know to create your own amazing designs.<br/>  <br/> Also included are three gorgeous pastel-colored cake projects, piped with buttercream, that are impressive and stylish—in addition to being completely delicious.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fiona Pearce
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b9224200